import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AdminTemplateState } from 'src/types/plan.interface'

import {
  adminUploadTemplateLastModifiedDateTime,
  downloadAdminUploadTemplate,
} from '../actions/download-admin-upload-template'

const initialState: AdminTemplateState = {
  error: null,
  lastModifiedDateTime: null,
  loading: false,
  templateData: null,
}

export const getAdminUploadTemplateAction = createAsyncThunk(
  '/load-pdf/admin-upload-template',
  async () => {
    return await downloadAdminUploadTemplate()
  }
)

export const templateLastModifiedDateTimeAction = createAsyncThunk(
  '/load-pdf/template-file-last-modified-date-time',
  async () => {
    return await adminUploadTemplateLastModifiedDateTime()
  }
)

const AdminTemplateSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(getAdminUploadTemplateAction.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAdminUploadTemplateAction.fulfilled, (state, action) => {
        state.templateData = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(getAdminUploadTemplateAction.rejected, (state, action) => {
        state.error =
          action.error.message ?? 'Error fetching admin upload template'
        state.loading = false
      })
      .addCase(templateLastModifiedDateTimeAction.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        templateLastModifiedDateTimeAction.fulfilled,
        (state, action) => {
          state.lastModifiedDateTime = action.payload
          state.loading = false
          state.error = null
        }
      )
      .addCase(templateLastModifiedDateTimeAction.rejected, (state, action) => {
        state.error =
          action.error.message ??
          'Error fetching template last modified date time'
        state.loading = false
      })
  },
  initialState,
  name: 'AdminTemplate',
  reducers: {
    resetAdminTemplateData: (state) => {
      state.templateData = null
      state.lastModifiedDateTime = null
      state.error = null
      state.loading = false
    },
  },
})

export const { resetAdminTemplateData } = AdminTemplateSlice.actions

export const { reducer: adminTemplateReducer } = AdminTemplateSlice
